import Dialog from '@mui/material/Dialog';
import styled from 'styled-components';

import ModalConfirmation from '../../../shared/ModalConfirmation';

export const ConfirmationModal = ({
  header,
  body,
  cancelText,
  submitText,
  open,
  onClose,
  onSave,
  variant = 'primary',
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <ModalWrapper>
        <ModalConfirmation
          header={header}
          body={body}
          cancelText={cancelText}
          submitText={submitText}
          variant={variant}
          cancelMode="outline"
          cancelVariant="black"
          onSave={onSave}
          onCancel={onClose}
        />
      </ModalWrapper>
    </Dialog>
  );
};

const ModalWrapper = styled.div`
  padding: 24px;
  width: 587px;
`;
